import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["controls", "viewport", "previous", "next"]

  connect() {
    this.dragging = false
    this.dragMoved = false
    this.suppressClick = false
    this.update()
  }

  disconnect() {
    window.clearTimeout(this.suppressClickTimeout)
  }

  previous() {
    this.scroll(-this.scrollDistance())
  }

  next() {
    this.scroll(this.scrollDistance())
  }

  startDrag(event) {
    if (event.pointerType !== "mouse" || event.button !== 0) {
      this.dragging = false
      return
    }

    window.clearTimeout(this.suppressClickTimeout)
    this.dragging = true
    this.dragMoved = false
    this.suppressClick = false
    this.dragStartX = event.clientX
    this.dragStartScrollLeft = this.viewportTarget.scrollLeft
  }

  drag(event) {
    if (!this.dragging) return

    const distance = event.clientX - this.dragStartX
    if (Math.abs(distance) < 5) return

    if (!this.dragMoved) {
      this.dragMoved = true
      this.viewportTarget.setPointerCapture(event.pointerId)
      this.viewportTarget.classList.add("is-dragging")
    }

    event.preventDefault()
    this.viewportTarget.scrollLeft = this.dragStartScrollLeft - distance
  }

  endDrag(event) {
    if (!this.dragging) return

    this.dragging = false
    this.viewportTarget.classList.remove("is-dragging")
    if (this.viewportTarget.hasPointerCapture(event.pointerId)) {
      this.viewportTarget.releasePointerCapture(event.pointerId)
    }

    if (this.dragMoved) {
      this.suppressClick = true
      this.suppressClickTimeout = window.setTimeout(() => { this.suppressClick = false }, 0)
    }
  }

  preventClickAfterDrag(event) {
    if (!this.suppressClick) return

    event.preventDefault()
    event.stopPropagation()
    this.suppressClick = false
  }

  preventNativeDrag(event) {
    event.preventDefault()
  }

  update() {
    const maximum = Math.max(0, this.viewportTarget.scrollWidth - this.viewportTarget.clientWidth)
    const hasOverflow = maximum > 2

    this.controlsTarget.hidden = !hasOverflow
    this.previousTarget.disabled = !hasOverflow || this.viewportTarget.scrollLeft <= 2
    this.nextTarget.disabled = !hasOverflow || this.viewportTarget.scrollLeft >= maximum - 2
  }

  scroll(left) {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.viewportTarget.scrollBy({ left, behavior: reducedMotion ? "auto" : "smooth" })
  }

  scrollDistance() {
    return Math.max(1, Math.floor(this.viewportTarget.clientWidth * 0.85))
  }
}
